import Logo from './logo/logo.png'
import LogoMini from './logo/logo-mini.png'
import LogoBlack from './logo/logo-black.png'
import LogoBlackMini from './logo/logo-black-mini.png'
import LogoWhiteMini from './logo/logo-white-mini.png'
import LogoWhite from './logo/logo-white.png'
import DefaultAvatar from './defaults/avatar.png'
import NoImageAvailable from './defaults/no-image.png'
export default { Logo, LogoMini, LogoBlack, LogoBlackMini, LogoWhiteMini, LogoWhite, DefaultAvatar,NoImageAvailable }
